module.exports = __webpack_public_path__ + "img/startup.1322573d.png";